import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';
import styles from './styles';

const FakeIconTextGroup = () => {
  const parentDiv = document.getElementsByClassName('container')[0] || window;
  const contentWidth = parentDiv.clientWidth || window.innerWidth;

  return (
    <div className="fake-icon-text-group">
      <ContentLoader height="80" width={contentWidth} {...fakeSettings}>
        <circle cx="50" cy="30" r="15" />
        <rect x="80" y="15" rx="1" ry="1" width="120" height="20" />
        <rect x="80" y="45" rx="1" ry="1" width="90" height="20" />
      </ContentLoader>
      <style jsx>{styles}</style>
    </div>
  );
};
export default FakeIconTextGroup;
